import {
  buildObjectivesTree,
  addChildObjectivesToNode,
  findAllNodesById,
} from "src/components/GoalsExplore/utils/objectivesTree.util";
import { updateTreeObject } from "src/shared/TreeView/TreeView.util";

import { GOALS_ACTIONS } from "../actionTypes";

const goalsReducer = (state, action) => {
  switch (action.type) {
    case GOALS_ACTIONS.LOAD_ROOT_OBJECTIVES: {
      const objectives = action.payload.objectives || [];

      const childrenMap = {};
      objectives.forEach((objective) => {
        childrenMap[objective.id] = {
          children: [],
          fetched: false,
        };
      });

      const treeData = buildObjectivesTree(objectives, childrenMap);

      treeData.forEach((node) => {
        Object.assign(node, {
          children: [{ noActivation: true, isPlaceholder: true, name: "" }],
          loading: false,
        });
      });

      return {
        ...state,
        treeData,
        childrenMap: {
          ...state.childrenMap,
          ...childrenMap,
        },
        loading: false,
        error: null,
      };
    }

    case GOALS_ACTIONS.LOAD_BRANCH_OBJECTIVES: {
      const { objectives = [], parentNodeId } = action.payload;

      const parentNodes = findAllNodesById(state.treeData, parentNodeId);

      if (parentNodes.length === 0) {
        return state;
      }

      const newChildrenMap = {
        ...state.childrenMap,
        [parentNodeId]: {
          children: objectives,
          fetched: true,
        },
      };

      objectives.forEach((objective) => {
        newChildrenMap[objective.id] = {
          children: [],
          fetched: false,
        };
      });

      parentNodes.forEach((parentNode) => {
        addChildObjectivesToNode(parentNode, objectives, newChildrenMap);

        if (parentNode.children && Array.isArray(parentNode.children)) {
          parentNode.children.forEach((childNode) => {
            if (!childNode.isPlaceholder) {
              Object.assign(childNode, {
                children: [
                  { noActivation: true, isPlaceholder: true, name: "" },
                ],
                loading: false,
              });
            }
          });
        }
      });

      return {
        ...state,
        treeData: updateTreeObject(state.treeData),
        childrenMap: newChildrenMap,
        loading: false,
        error: null,
      };
    }

    case GOALS_ACTIONS.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case GOALS_ACTIONS.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default goalsReducer;
